import { version } from 'process'
import appConfig from './appConfig.json'
export const config = {
  centricGraphQLEndpoint: '{{MIDDLEWARE_GRAPHQL_API_GATEWAY}}graphql',
  wsCentricGraphQLEndpoint: '{{MIDDLEWARE_GRAPHQL_API_WS_GATEWAY}}graphql',
  centricRestEndpoint: '{{MIDDLEWARE_REST_API_GATEWAY}}',
  pdfServiceEndPoint: '{{PDF_SERVICE_ENDPOINT}}',
  authServiceEndPoint: '{{OAUTH_SERVICE_ENDPOINT}}',
  bridgeServiceEndpoint: '{{BRIDGE_SERVICE_ENDPOINT}}',
  buyingBoardServiceRestEndpoint: '{{BUYING_BOARD_SERVICE_MIDDLEWARE_REST_API_GATEWAY}}',
  customerName: '{{SALES_BOARD_APP_LOGO}}',
  wijmoLicenseKey: '{{WIJMO_LICENSE_KEY}}',
  enableSSO: '{{ENABLE_SSO}}',
  centricURL: '{{CENTRIC_URL}}',
  centralWholesalePriceListGroup: '{{CENTRAL_WHL_PRICELIST_GROUP}}',
  centralWholesalePriceListType: '{{CENTRAL_WHL_PRICELIST_TYPE}}',
  centralSRPPriceListGroup: '{{CENTRAL_SRP_PRICELIST_GROUP}}',
  centralSRPPriceListType: '{{CENTRAL_SRP_PRICELIST_TYPE}}',
  centralRetailPriceListGroup: '{{CENTRAL_RETAIL_PRICELIST_GROUP}}',
  centralRetailPriceListType: '{{CENTRAL_RETAIL_PRICELIST_TYPE}}',
  centralCustomPriceGroup: '{{CENTRAL_CUSTOM_SRP_PRICELIST_GROUP}}',
  centralCustomPriceType: '{{CENTRAL_CUSTOM_SRP_PRICELIST_TYPE}}',
  pricesFilterType: '{{PRICES_FILTER_TYPE}}',
  vipRangePlanBusinessHierarchy: '{{VIP_RANGE_PLAN_BUSINESS_HIERARCHY}}',
  globalCurrency: '{{GLOBAL_CURRENCY}}',
  environment: `{{ENVIRONMENT}}`,
  jobStatusPollInterval: '{{JOB_STATUS_POLL_INTERVAL}}',
  notificationPollInterval: '{{NOTIFICATION_POLL_INTERVAL}}',
  defaultQuantityType: {
    Wholesale: '{{WHOLESALE_QUANTITY_TYPE}}',
    Retail: '{{RETAIL_QUANTITY_TYPE}}'
  },
  bulkUpdateClusterExclusion: '{{BULK_UPDATE_CLUSTER_EXCLUSION}}',
  productRequestUrl: '{{PRODUCT_REQUEST_URL}}',
  integrationSettings: {
    import: '{{INTEGRATION_SETTINGS_IMPORT}}',
    export: '{{INTEGRATION_SETTINGS_EXPORT}}',
    exportOrderOnReview: '{{INTEGRATION_SETTINGS_EXPORT_ORDER_ON_REVIEW}}'
  },
  pdfExportLimit: '{{PDF_EXPORT_MAX_LIMIT}}',
  assortmentSource: {
    wholesale: '{{WHOLESALE_ASSORTMENT_SOURCE}}',
    retail: '{{RETAIL_ASSORTMENT_SOURCE}}'
  },
  deliveryWindowExcludedZones: '{{DELIVERY_WINDOW_EXCLUDED_ZONES}}',
  displayAvgDepthAndTotalStoresInQtyView:
    '{{DISPLAY_AVG_DEPTH_AND_TOTAL_STORES_IN_QTY_VIEW}}',
  displayWholesalePriceInRetailSHR: '{{DISPLAY_WHL_PRICE_IN_RETAIL_SHR}}',
  highlightQtyDiscrepanciesInSHR: '{{HIGHLIGHT_QTY_DISCREPANCIES_IN_SHR}}',
  highlightBookUnbookDoorDiscrepanciesInSHR:
    '{{HIGHLIGHT_BOOK_UNBOOK_DOOR_DISCREPANCIES_IN_SHR}}',
  allowAddremoveProductInOrderView: '{{ALLOW_ADD_REMOVE_PRODUCT_IN_ORDER_VIEW}}',
  localization: {
    source: '{{LOCALIZATION_SOURCE}}',
    locize: {
      projectId: '{{LOCALIZATION_LOCIZE_PROJECT_ID}}',
      apiKey: '{{LOCALIZATION_LOCIZE_API_KEY}}',
      version: '{{LOCALIZATION_LOCIZE_VERSION}}',
      private: '{{LOCALIZATION_LOCIZE_PRIVATE}}',
      referenceLng: '{{LOCALIZATION_LOCIZE_REF_LANGUAGE}}',
      saveMissing: '{{LOCALIZATION_SAVE_MISSING}}',
      currencyDisplayFormat: '{{LOCALIZATION_CURRENCY_DISPLAY_FORMAT}}'
    },
    defaultLanguage: '{{LOCALIZATION_DEFAULT_LANGUAGE}}',
    fallbackLanguage: '{{LOCALIZATION_FALLBACK_LANGUAGE}}',
    defaultNamespace: '{{LOCALIZATION_DEFAULT_NAMESPACE}}',
    fallbackNamespace: '{{LOCALIZATION_FALLBACK_NAMESPACE}}'
  },
  appConfig
}
